// import PlusButton2 from "./PlusButton2";
import { useHistory } from "react-router";
import { useRecoilState, useRecoilValue } from "recoil";
import { isAddInvoice } from "../modules/CarrierAgreementMgmt/VendorInvoice/InvoiceCapture/atoms/atoms";
import { selectedVIPTab } from "../modules/CarrierAgreementMgmt/VendorInvoice/InvoiceManager/atoms/atoms";
import { VendorInvoiceTabs } from "../modules/CarrierAgreementMgmt/VendorInvoice/VendorInvoiceTabs";
import { permissionsSelector } from "../modules/Login/selectors/permissionSelector";
import AddButton from "./AddButton";

const VIPMediumCard = ({
  title,
  showPlustButton,
  cardRowName1,
  cardRowName2,
  cardRowName3,
  cardRowCount1,
  cardRowCount2,
  cardRowCount3,
  className,
}) => {
  const [showUploadModal, setShowUploadModal] = useRecoilState(isAddInvoice);
  const history = useHistory();
  const [selectedIndex, setSelectedIndex] = useRecoilState(selectedVIPTab);
  const userPermissions = useRecoilValue(permissionsSelector);
  const currentTabs = VendorInvoiceTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  return (
    <>
      <div className="bg-white border border-gray-200 shadow-md  rounded-md">
        <div className="grid grid-cols-1 md:grid-cols-2 justify-between p-2">
          <div className="w-full">
            <div className="p-2 font-medium flex flex-row justify-between">
              <h1 className="mr-auto truncate text-quinary text-quinary text-quinary text-primary">
                {title}
              </h1>
            </div>
          </div>
          {showPlustButton && (
            <div className="mr-3 pl-1 mt-1.5 flex h-8 flex justify-end py-0.5">
              <AddButton
                buttonText="Add Invoice"
                onClick={() => {
                  const url = "/vendortab/invoice/pending";
                  history.push(url);
                  const index = currentTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);

                  setShowUploadModal(true);
                }}
              />
            </div>
          )}
        </div>
        <div className="grid gap-3 mx-5 pb-5">
          <div className="bg-LightWhite text-tertiary hover:bg-secondary hover:text-white text-sm shadow h-10 rounded-md justify-between flex">
            <div className="ml-2 mt-2 underline">{cardRowName1}</div>
            <div className="text-right mr-5 mt-2 font-bold">
              {cardRowCount1}
            </div>
          </div>
          <div className="bg-LightWhite text-tertiary hover:bg-secondary hover:text-white text-sm shadow h-10 rounded-md justify-between flex">
            <div className="ml-2 mt-2 underline">{cardRowName2}</div>
            <div className="text-right mr-5 mt-2 font-bold">
              {cardRowCount2}
            </div>
          </div>
          <div className="bg-LightWhite text-tertiary hover:bg-secondary hover:text-white text-sm shadow h-10 rounded-md justify-between flex">
            <div className="ml-2 mt-2 underline">{cardRowName3}</div>
            <div className="text-right mr-5 mt-2 font-bold">
              {cardRowCount3}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VIPMediumCard;
